module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-billed-records"
  }, [_c('table', [_vm._m(0), _c('tbody', _vm._l((_vm.item.records), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _c('td', [_vm._v(_vm._s(item.driver_id))]), _c('td', [_vm._v(_vm._s(_vm._f("walletableType")(item.walletable_type)) + " - " + _vm._s(item.walletable_id))]), _c('td', [_vm._v(_vm._s(_vm.$priceWithcurrency(parseFloat(item.amount * item.tax).toFixed(2))))]), _c('td', [_vm._v(_vm._s(-item.tax * 100) + "%")]), _c('td', [_vm._v(_vm._s(_vm.$priceWithcurrency(-item.amount)))])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Id")]), _c('th', [_vm._v("Driver Id")]), _c('th', [_vm._v("Type & Id")]), _c('th', [_vm._v("Tax")]), _c('th', [_vm._v("Tax Rate")]), _c('th', [_vm._v("Amount")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27102115!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/BilledRecords.vue
// module id = 2355
// module chunks = 1